<template>
  <div class="text-gray-600 ota-p16 mb-7">
    <table class="pt-rem w-full">
      <tbody class="mb-4">
        <tr>
          <td class="lg:pb-rem">
            {{ $t('Loyalty.Webshop.Checkout.Item') }}
          </td>
          <td class="lg:pb-rem">
            {{ $t('Loyalty.Webshop.Checkout.Description') }}
          </td>
          <td class="lg:pb-rem">
            {{ $t('Loyalty.Webshop.Checkout.Color') }}
          </td>
          <td class="lg:pb-rem">
            {{ $t('Loyalty.Webshop.Checkout.Size') }}
          </td>
          <td class="lg:pb-rem">
            {{ $t('Loyalty.Webshop.Checkout.Quantity') }}
          </td>
          <td class="lg:pb-rem">
            {{ $t('Loyalty.Webshop.Checkout.Amount') }}
          </td>
        </tr>
      </tbody>
      <tbody class="border-orange-300 border-b-2">
        <tr>
          <td class="pt-4 pb-rem lg:hidden">
            {{ $t('Loyalty.Webshop.Checkout.Size') }}
          </td>
          <td class="pt-4 pb-rem lg:hidden">
            {{ $t('Loyalty.Webshop.Checkout.Quantity') }}
          </td>
          <td class="pt-4 pb-rem lg:hidden">
            {{ $t('Loyalty.Webshop.Checkout.Amount') }}
          </td>
        </tr>
      </tbody>
      <tbody
        v-for="(product, index) in products"
        :key="`${product.productId}-${index}`"
        class="border-b border-gray-200"
      >
        <tr>
          <td class="py-4">
            <div class="photo-container">
              <OImage
                v-bind="getImagePaths(`/images/frontend/loyalty/products/${product.slug}/product`)"
                img-class="rounded"
              />
            </div>
          </td>
          <td class="py-4">
            {{ product.name }}
          </td>
          <td class="py-4">
            {{ product.color }}
          </td>
          <td class="py-4">
            {{ product.sizeLabel }}
          </td>
          <td class="py-4">
            {{ product.quantity }}
          </td>
          <td class="py-4">
            {{ toEuros(product.price) }}
          </td>
        </tr>
        <tr>
          <td class="py-4 lg:hidden">
            {{ product.sizeLabel }}
          </td>
          <td class="py-4 lg:hidden">
            {{ product.quantity }}
          </td>
          <td class="py-4 lg:hidden">
            {{ toEuros(product.price) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { getEuros, getImagePaths } from '@/utils/general'
import { mapState } from 'vuex'
import OImage from '@/components/OImage'

export default {
  name: 'WebshopOrderSummary',
  components: { OImage },
  props: {
    products: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    ...mapState('app', {
      country: state => state.country
    })
  },
  methods: {
    toEuros (price = '0') {
      return getEuros(this.country, price, true)
    },
    getImagePaths (path = '') {
      return getImagePaths({ path, extension: '.webp', s3: true })
    }
  }
}
</script>

<style lang="postcss" scoped>
tbody {
  .photo-container {
    width: 4.4rem;
    height: 6.6rem;

    .oimage >>> img {
      @apply object-cover min-h-full max-h-full min-w-full;
      max-width: 100% !important;
    }
  }

  tr {
    td {
      @apply align-top;
      width: 33%;

      &:nth-child(3) {
        text-align: right;
      }

      &:nth-child(4), &:nth-child(5), &:nth-child(6) {
        @apply hidden;
      }

      &:nth-child(6) {
        @apply text-right;
      }
    }
  }
}

@screen md {
  tbody {
    .photo-container {
      width: 8.2rem;
      height: 12.4rem;
    }
  }
}

@screen lg {
  tbody {
    tr {
      td {
        @apply px-rem;
        width: 16.6666666667%;

        &:nth-child(1) {
          @apply pl-0;
        }

        &:nth-child(6) {
          @apply pr-0;
        }

        &:nth-child(3) {
          text-align: center;
        }

        &:nth-child(4), &:nth-child(5), &:nth-child(6) {
          @apply table-cell;
        }
      }
    }
  }
}
</style>
